import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box'; 

// *** สมมติว่า path เหล่านี้ถูกต้อง ***
import timage1 from '../images/dev.png';
import timage2 from '../images/sa.png';
import timage3 from '../images/imp.png';
import timage4 from '../images/tech.png';

const teamsData = [
    {
        title: 'DEVELOPER',
        content: 'เรามีทีมพัฒนาระบบที่เป็นฝีมือคนไทย ซึ่งง่ายต่อการจัดการแก้ไขหรือพัฒนาต่อยอด ซึ่งต่างจากระบบสำเร็จรูปที่เป็นการนำเข้ามาใช้ในประเทศทั่วไป ยากต่อการแก้ไขหรือพัฒนาต่อยอด ทำให้ Logins Medical เป็นบริษัท Software ที่่โดดเด่นในเรืองการการควบคุมคุณภาพ Software ได้ด้วยตัวเอง',
        image: timage1,
        alt: 'Developer',
    },
    {
        title: 'SYSTEM ANALYSIS',
        content: 'ทีมวิเคราห์ระบบ ที่ชำนาญเรื่องของ Software และส่วนงานเทคนิคการแพทย์ ซึ่งทำให้การสื่อสารกับเจ้าหน้าที่และ ส่วนของผู้พัฒนาระบบสื่อสารได้ดีและถูกจุดประสงค์ ส่งผลให้ ระบบสามารถตอบสนองการใช้งานของ User ได้มากกว่าโปรแกรมสำเร็จรูปทั่วไป รวมถึงตอบรับนโยบายกระทรวงได้อีกด้วย',
        image: timage2,
        alt: 'System Analysis',
    },
    {
        title: 'LIS EXCLUSIVE',
        content: 'การตอบสนองผู้ใช้งานได้รวดเร็วถือเป็นหนึ่งในส่วนงานบริการที่่เราภาคภูมิใจ การติดตั้งระบบ จำเป็นต้องมีความเข้าใจทั้งผู้ใช้และความสามารถของระบบ ทีม Implement จึงมีความชำนาญด้านระบบ ผนวกกับมีความเข้าใจระบบงานของเจ้าหน้าที่เทคนิคการแพทย์ หรือเจ้าหน้าที่ส่วนอื่นๆของสถานพยาบาลได้ดีอีกด้วย',
        image: timage3,
        alt: 'LIS EXCLUSIVE',
    },
    {
        title: 'INSTRUMENT',
        content: 'ขาดไม่ได้กีบทีมทีี่คอยซัพพอตตัวเครื่องให้สามารถใช้งานระบบได้อย่างต่อเนื่อง ทั้งการประเมินเครื่องและการแก้ไขปัญหา การเชื่อต่อระบบกับเครื่องเจ้าหน้าที่มีความชำนาญการทำการปฎิบัติงาน การเก็บข้อมูลเครื่อง ภาษาเฉพาะของเครื่อง ที่สื่อสารกับตัวระบบการส่งออกและนำเข้าข้อมูลระหว่างระบบกับตัวเครื่อง',
        image: timage4,
        alt: 'INSTRUMENT',
    },
];

const Teams = () => {
    
    // 💡 สไตล์สำหรับ CardContent ที่วางซ้อนทับบนรูปภาพและชิดด้านล่าง
    const overlayContentStyle = {
        position: 'absolute',
        bottom: 0, // *** สำคัญ: จัดให้อยู่ชิดขอบล่าง ***
        left: 0,
        right: 0,
        backgroundColor: '#2f365bc9', // เพิ่มความเข้มเพื่อให้ข้อความอ่านง่ายขึ้น
        color: 'white',
        padding: '16px', 
        zIndex: 2, 
    };

    // สไตล์สำหรับเอฟเฟกต์ Blur และ Dim Overlay
    const blurOverlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backdropFilter: 'blur(0px)', 
        backgroundColor: 'rgba(88, 45, 32, 0.34)', 
        zIndex: 1,
    };
    
    return (
        <div id='ourteams'>
            <h1>OUR TEAMS</h1>

            {/* Flexbox Container: จัดให้ Card มีความสูงเท่ากัน */}
            <div className='a-container' style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '20px', 
                justifyContent: 'center',
                alignItems: 'stretch' 
            }}>
                
                {teamsData.map((team, index) => (
                    <div className='team-box' key={index} style={{ 
                        width: '300px', 
                        display: 'flex', 
                        flexDirection: 'column' 
                    }}>
                        <Card sx={{ 
                            maxWidth: 345, 
                            height: '100%' // Card ยืดเต็มความสูงของ team-box
                        }}>
                            <Tooltip title={team.title}>
                                <CardActionArea sx={{ 
                                    position: 'relative', 
                                    height: '100%' // ActionArea ยืดเต็ม Card (เป็นจุดอ้างอิง)
                                }}> 
                                    
                                    {/* 1. รูปภาพหลัก (ขยับชิดด้านบนและยืดเต็มพื้นที่) */}
                                    <CardMedia
                                        component="img"
                                        height="100%" // *** สำคัญ: ทำให้รูปภาพยืดเต็ม ActionArea ***
                                        image={team.image}
                                        alt={team.alt}
                                        sx={{ 
                                            objectFit: 'cover', // เพื่อให้รูปภาพไม่บิดเบี้ยว
                                            position: 'absolute', 
                                            top: 0 // *** สำคัญ: จัดรูปภาพให้อยู่ชิดขอบบน ***
                                        }} 
                                    />
                                    
                                    {/* 2. Overlay สำหรับ Blur และ Dim */}
                                    <Box sx={blurOverlayStyle} />
                                    
                                    {/* 3. ข้อความที่วางซ้อนทับ (ชิดด้านล่าง) */}
                                    <Box sx={overlayContentStyle}>
                                        {/* หัวข้อ */}
                                        <Typography gutterBottom fontFamily='prompt' variant="h5" component="div" sx={{ color: 'white' }}>
                                            {team.title}
                                        </Typography>
                                        {/* เนื้อหา */}
                                        <Typography gutterBottom fontFamily='prompt' variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                                            {team.content}
                                        </Typography>
                                    </Box>
                                    
                                </CardActionArea>
                            </Tooltip>
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Teams;